import { type ComponentProps } from "react";

const AidIcon2 = (props: ComponentProps<"svg">) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" {...props}>
      <g opacity="1">
        <path
          d="M27.5 13.5C27.5 20.9558 21.4558 27 14 27C6.54416 27 0.5 20.9558 0.5 13.5C0.5 6.04416 6.54416 0 14 0C21.4558 0 27.5 6.04416 27.5 13.5Z"
          fill="currentColor"
        />
        <path
          d="M12.2675 17.0775L12.155 13.1175L13.82 13.005C14.6 12.96 15.2375 12.735 15.7325 12.33C16.2425 11.925 16.4975 11.3325 16.4975 10.5525C16.4975 9.8925 16.265 9.345 15.8 8.91C15.335 8.475 14.7275 8.2575 13.9775 8.2575C13.4525 8.2575 12.995 8.3925 12.605 8.6625C12.23 8.9175 11.9675 9.24 11.8175 9.63L9.1175 8.865C9.4175 7.875 9.9875 7.08 10.8275 6.48C11.6825 5.88 12.7325 5.58 13.9775 5.58C15.0275 5.58 15.9575 5.7975 16.7675 6.2325C17.5775 6.6525 18.2075 7.2375 18.6575 7.9875C19.1225 8.7225 19.355 9.5775 19.355 10.5525C19.355 11.3475 19.1825 12.06 18.8375 12.69C18.4925 13.32 17.9975 13.83 17.3525 14.22C16.7225 14.61 15.9875 14.8575 15.1475 14.9625L15.1025 17.0775H12.2675ZM13.685 21.9375C13.19 21.9375 12.7625 21.765 12.4025 21.42C12.0575 21.06 11.885 20.625 11.885 20.115C11.885 19.62 12.0575 19.2 12.4025 18.855C12.7625 18.495 13.19 18.315 13.685 18.315C14.18 18.315 14.6 18.495 14.945 18.855C15.305 19.2 15.485 19.62 15.485 20.115C15.485 20.625 15.305 21.06 14.945 21.42C14.6 21.765 14.18 21.9375 13.685 21.9375Z"
          fill="#F2F3FF"
        />
      </g>
    </svg>
  );
};

export default AidIcon2;